import { Card } from '../../../layout/Card.jsx';
import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD } from '../../../shared/format.js';

// تقرير الفواتير المعلّقة يعيد `rows` (لا `items`) حتى تصل الإجماليات معه
// دون أن يفكّه مُعترض api إلى مصفوفة مجرّدة.
function asArray(d) {
  return Array.isArray(d) ? d : d?.rows || d?.data || d?.items || [];
}

function MiniCard({ tone, icon, title, count, items, empty, formatter }) {
  const tones = {
    warning: 'bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]',
    danger: 'bg-[#FEE2E2] text-[#B91C1C] border-[#FCA5A5]',
    info: 'bg-[#CFFAFE] text-[#0E7490] border-[#67E8F9]'
  };

  return (
    <div className={`card border ${tones[tone] || tones.info} p-3.5`}>
      <div className="flex items-center gap-2 mb-2">
        <div className="w-8 h-8 rounded-[10px] bg-white/60 grid place-items-center">
          <Icon name={icon} size={16} />
        </div>
        <div className="flex-1">
          <div className="font-bold text-[13px]">{title}</div>
          <div className="text-[11px] opacity-80">{count} عنصر</div>
        </div>
      </div>
      {items.length ? (
        <ul className="text-[12px] space-y-1">
          {items.slice(0, 3).map((it, i) => (
            <li key={i} className="flex items-center justify-between gap-2">
              <span className="truncate">{it.label}</span>
              {formatter && it.value != null ? (
                <span className="font-bold flex-none">{formatter(it.value)}</span>
              ) : null}
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-[12px] opacity-70">{empty}</div>
      )}
    </div>
  );
}

export function AlertsPanel({ activeSessions, pendingInvoices, lowStock }) {
  const sessionsArr = asArray(activeSessions);
  const overstays = sessionsArr.filter(
    (s) => s.overstay || s.status === 'overtime' || s.minutesOver > 0
  );

  // المبلغ المعروض هو المستحق (`dueAmount`) لا الإجمالي: الفاتورة الجزئية
  // معلّقة ببقيتها فقط. قراءة `totalAmount`/`amount` وحدها كانت تُظهر صفراً
  // لكل فاتورة — فاتورة المبيعات لا تحمل أياً من المفتاحين.
  const pendingArr = asArray(pendingInvoices)
    .map((p) => ({
      label: p.customerName
        || p.childName
        || p.child?.name
        || p.guardianName
        || (p.number ? `فاتورة ${p.number}` : '—'),
      value: Number(
        p.dueAmount
          ?? p.totalAmount
          ?? p.amount
          ?? (Number(p.grandTotal || 0) - Number(p.paidAmount || 0))
      ) || 0
    }))
    .sort((a, b) => b.value - a.value);

  const lowStockArr = asArray(lowStock).map((p) => ({
    label: p.name || p.productName || '—',
    value: p.stock ?? p.quantity ?? null
  }));

  return (
    <Card header="التنبيهات">
      <div className="grid gap-3" style={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
        <MiniCard
          tone="warning"
          icon="clock"
          title="تجاوز الوقت"
          count={overstays.length}
          items={overstays.slice(0, 3).map((c) => ({
            label: c.childName || c.child?.name || c.name || '—'
          }))}
          empty="لا توجد جلسات متجاوزة"
        />
        <MiniCard
          tone="danger"
          icon="checkout"
          title="فواتير معلقة"
          count={pendingInvoices?.count ?? pendingArr.length}
          items={pendingArr.slice(0, 3)}
          empty="لا توجد فواتير معلقة"
          formatter={formatIQD}
        />
        <MiniCard
          tone="info"
          icon="inventory"
          title="مخزون منخفض"
          count={lowStockArr.length}
          items={lowStockArr.slice(0, 3)}
          empty="المخزون مستقر"
        />
      </div>
    </Card>
  );
}
